import React from "react";

type IProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const RadioLabel: React.FC<IProps> = (props) => (
  <label {...props} className="fs-radio__label interactive" />
);
